import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const KettleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "KettleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.1092 7.02408C19.9464 5.7868 18.88 4.85881 17.6265 4.85881H16.6822C16.5683 4.42739 16.4706 4.05299 16.381 3.73553C16.1613 2.92153 15.4124 2.35986 14.574 2.35986H8.95734C8.11892 2.35986 7.37004 2.92967 7.15025 3.73553C7.06071 4.04485 6.96304 4.42739 6.84908 4.85881H4.26053C4.06517 4.85881 3.8861 4.94839 3.764 5.10305C3.6419 5.25771 3.60119 5.45305 3.65003 5.64027C3.86981 6.25891 3.94307 7.93574 5.50595 9.49048L5.77459 9.75912C5.28619 12.4372 4.88733 15.5711 4.88733 18.6155V20.4877C4.88733 21.5215 5.72574 22.3599 6.75953 22.3599H16.7636C17.7974 22.3599 18.6358 21.5215 18.6358 20.4877V18.6155C18.6358 14.0245 17.716 9.23003 16.9834 6.1124H17.6183C18.2451 6.1124 18.7823 6.5764 18.8637 7.19504L19.8975 14.9443C19.9382 15.2618 20.2068 15.4897 20.5162 15.4897C20.5406 15.4897 20.5732 15.4897 20.5976 15.4897C20.9395 15.4408 21.1837 15.1315 21.1348 14.7896L20.101 7.04038L20.1092 7.02408ZM8.35496 4.06925C8.42822 3.80063 8.68058 3.61341 8.95734 3.61341H14.574C14.8507 3.61341 15.103 3.80063 15.1763 4.06925C15.2414 4.29717 15.3147 4.56577 15.388 4.85881H8.14334C8.2166 4.56577 8.28984 4.29717 8.35496 4.06925ZM5.06641 6.1124H6.53975C6.38509 6.75547 6.23042 7.47178 6.06762 8.24509C5.2292 7.21944 5.11524 6.26706 5.05826 6.1124H5.06641ZM16.7718 21.1145H6.76767C6.42579 21.1145 6.14088 20.8377 6.14088 20.4877V19.8609H17.3985V20.4877C17.3985 20.8295 17.1218 21.1145 16.7718 21.1145ZM17.3985 18.6155H6.14088C6.14088 13.9919 7.10141 9.14863 7.83401 6.1124H15.7054C16.438 9.14863 17.3985 14.0001 17.3985 18.6155Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default KettleIcon;
